import React, { useState, useEffect } from "react";
import axiosConfig from "../../Service/AxiosConfig";
import { useParams } from "react-router-dom";
import BlogComponent from "../BlogComponent/BlogComponent";
import BlogDetail from "../BlogComponent/BlogDetail";

export const FriendlyUrlComponent = () => {
  let { slug, seo_url } = useParams();
  console.log(seo_url);
  console.log(slug);

  const [loading, setLoading] = useState(false);
  const [ProductObject, setProductObject] = useState({
    product_type: "",
    product_data: "",
  });
  const [Data, SetData] = useState([]);
  const GetData = async () => {
    setLoading(true);
    try {
      const response = await axiosConfig.get(`/catlog/seo-url/${seo_url}/`);
      console.log(response, "kk");
      setProductObject({
        product_type: response.data.product_type,
        product_data: response.data.product_data,
      });
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    GetData();
  }, [seo_url]);

  return (
    <>
      <div className="categories-container">
        {loading ? (
          <div className="loader-container">loader....</div>
        ) : (
          <div className="">
            {ProductObject.product_type == "blogcategory" && (
              <BlogComponent category={ProductObject.product_data.id} />
            )}
            {ProductObject.product_type == "blog" && (
              <BlogDetail item={ProductObject.product_data} />
            )}
          </div>
        )}
      </div>
    </>
  );
}; 
